import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50d855ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chat-plan-locked-page"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanFeatureLocked = _resolveComponent("PlanFeatureLocked")!
  const _component_ChatContent = _resolveComponent("ChatContent")!

  return (_ctx.isAttendantUnavailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_PlanFeatureLocked, {
          class: "chat-plan-locked-panel",
          title: "Conversas indisponiveis no seu plano atual",
          message: "O modulo de conversas depende do atendimento automatico. Troque de plano para liberar o chatbot e acompanhar os atendimentos por aqui."
        })
      ]))
    : (_openBlock(), _createBlock(_component_ChatContent, { key: 1 }))
}